import React from "react";
import { Text } from "../../Kit";
import {useLanguage} from "../../../Store/modules/language";

type ToggleSwitchProps = {
  label: string;
  description: string;
  boxClassName?: string;
  checked: boolean;
  onChange: (value: boolean) => void;
};

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({checked,onChange,label,description,boxClassName}) => {
  const { direction } = useLanguage();
  return (
      <div className={`flex justify-between ${boxClassName ?? ""}`} dir={direction}>
        <div>
          <Text elementType="p" className="text-sm font-medium text-start">{label}</Text>
          <Text elementType="p" color="iconColor" className="text-xs text-start mt-1">{description}</Text>
        </div>
        <button
            type="button"
            dir="ltr"
            className={`h-6 rounded-full p-1 transition-colors duration-300 min-w-[41px] max-w-[42px]
               ${checked ? "bg-blue-600" : "bg-gray-300"}`}
            onClick={() => onChange(!checked)}
        >
          <div
              className={`w-4 h-4 rounded-full bg-white shadow-md transform transition-transform duration-300
                ${checked ? "translate-x-4" : "translate-x-0"}`}
          />
        </button>
      </div>
  );
};